export const SAMPLES_LIST = "samples";
export const QUERY_PARAM_RECORD_LIST = "record-list";
